(function() {
  const path = window.location.pathname;

  
  const overrides = [
    {
      match: '/policies/refund-policy',                
      newTitle: 'Rückgabe & Erstattungsrichtlinie'
    },
    {
      match: '/policies/shipping-policy',
      newTitle: 'Versandrichtlinie'
    },
    {
      match: '/pages/cookies-politik',
      newTitle: 'Cookie-Richtlinie'
    }
  ];

  
  const override = overrides.find(o => path.includes(o.match));
  if (!override) return;

  const newTitle = override.newTitle;

  
  document.title = newTitle;

  
  document.documentElement.style.visibility = 'hidden';

 
  const observer = new MutationObserver((mutations, obs) => {
    const h1 = document.querySelector('h1');
    if (h1) {
      h1.textContent = newTitle;
      document.documentElement.style.visibility = 'visible';
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
